import React from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import AuthedImage from '@/components/AuthedImage';

/**
 * A full-screen tap-to-enlarge overlay for one image at a time. Extracted
 * from ContactRow.jsx's own lightbox (task: the same full-size photo
 * behavior on Edit Contact, 2026-09-24), so both places share one real
 * implementation instead of two copies that can quietly drift apart.
 *
 * `src` is the image URL currently open (already `/api/images/...`
 * prefixed, same as everywhere else in this app), or null/undefined to
 * render nothing. The caller owns that one piece of state, same as
 * ContactRow.jsx always has, a plain `useState(null)`: only the caller
 * knows how many tappable photos its own page has and which one was
 * tapped.
 */
export default function ImageLightbox({ src, onClose }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-4"
          onClick={onClose}
        >
          <button className="absolute top-4 right-4 p-2 bg-white/20 rounded-full hover:bg-white/30" onClick={onClose}>
            <X className="w-5 h-5 text-white" />
          </button>
          <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }} onClick={(e) => e.stopPropagation()}>
            <AuthedImage src={src} alt="" className="max-w-full max-h-full rounded-xl object-contain" fallbackClassName="w-64 h-64 rounded-xl" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
